import { memo } from "react";
import { ResponsiveImage } from "@made-people/blueprint-responsive-image";
import { LinkAsLink } from "@made-people/blueprint-link";
import { useTranslate } from "@made-people/grease-translations";
import type { Order } from "@made-people/grease-order";
import { getOrderItemImages, getOrderDate } from "./mm-account-orders/utils";

const imagePlaceholder = (
  <div className="w-16 flex-none aspect-product-image bg-neutral-100 rounded-lg" />
);

export const RecentOrderCard = memo(function RecentOrderCard({
  order,
  viewOrderHref,
}: {
  order: Order;
  viewOrderHref: string | undefined;
}) {
  const translate = useTranslate();
  const images = getOrderItemImages(order);
  const firstImage = images[0];
  const statusLabel = translate(`Account_Order_Status_${order.status}`);

  return (
    <div className="flex-none w-56 rounded-xl border border-border-light bg-white p-3 flex flex-row gap-3">
      {firstImage ? (
        <ResponsiveImage
          image={{ src: firstImage, alt: "" }}
          loading="lazy"
          displaySize="64px"
          className="w-16 flex-none aspect-product-image object-cover rounded-lg"
        />
      ) : (
        imagePlaceholder
      )}
      <div className="flex flex-col gap-1 min-w-0 justify-between">
        <div className="flex flex-col gap-0.5">
          <span className="text-label-sm font-medium uppercase tracking-wide">
            #{order.orderNumber}
          </span>
          <span className="text-body-xs text-text-less-emphasis-1">
            {getOrderDate(order)}
          </span>
          <span className="text-body-xs capitalize">{statusLabel}</span>
        </div>
        {viewOrderHref && (
          <LinkAsLink
            label={translate("Account_View_Order")}
            link={{ href: viewOrderHref }}
            variants={{ style: "underline" }}
            className="text-label-sm"
          />
        )}
      </div>
    </div>
  );
});
